import React from "react";
import "@mkhuda/react-shaka-player/dist/ui.css";
import {
  StyledSubContainer,
  ContextContainer,
  MovieTitle,
  ButtonContainer,
  MovieWrapper,
} from "./styled";
import { ReactShakaPlayer } from "@mkhuda/react-shaka-player";
import ContextMenu from "../../components/ContextMenu";
import { Button, Modal, createStyles } from "@mui/material";
import { mainFont, black, white } from "../../utils/StyleHelpers";
import { locale } from "../../utils/LocaleManager";
import { PlayerDialogProps } from "../../types/PlayerDialogProps";

const buttonStyle = createStyles({
  backgroundColor: white,
  color: black,
  fontFamily: mainFont,
  textTransform: "uppercase",
  borderRadius: "0.5rem",
  display: "flex",
  width: "12.5rem",
  padding: "1rem",
  fontSize: "1.25rem",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "normal",
});

const PlayerDialog = ({
  onCopyLinks,
  onDownload,
  onClickEdit,
  onClickDetails,
  name,
  url,
  onPlayerError,
  onClose,
  onClickRename,
}: PlayerDialogProps) => {
  return (
    <Modal
      open={true}
      onClose={() => {}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{
        background: "rgba(0, 0, 0, 0.8)",
      }}
    >
      <StyledSubContainer>
        <ContextContainer>
          <ContextMenu
            isShowPlayer={true}
            onCopyLinks={onCopyLinks}
            onDownload={onDownload}
            onClickEdit={onClickEdit}
            onClickDetails={onClickDetails}
            onClickRename={onClickRename}
          />
        </ContextContainer>
        <MovieWrapper>
          <MovieTitle>{name}</MovieTitle>
          <ReactShakaPlayer
            uiConfig={{ enableFullscreenOnRotation: false }}
            playerClassName="stplayer"
            autoPlay={true}
            src={url}
            onPlayerError={onPlayerError}
          />
        </MovieWrapper>
        <ButtonContainer>
          <Button variant="contained" onClick={onClose} style={buttonStyle}>
            {locale.close}
          </Button>
        </ButtonContainer>
      </StyledSubContainer>
    </Modal>
  );
};

export default PlayerDialog;
